export const ELIF_PROMPT_NAME = 'ELI5';